import { CalorieDeviationResponse } from "@/clients/models/CalorieDeviationResponse";
import { BalanceService } from "@/clients/services/BalanceService";
import { QueryKeys } from "@/constants/query-keys";
import { QueryStaleTime } from "@/constants/query-stale-time";
import { guardGetUserFromLocalStorage } from "@/utils/request";
import { useQuery } from "@tanstack/react-query";

export const useGetCalorieDeviation = () => {
  const { data, isLoading, isError, error, refetch } = useQuery({
    queryKey: [QueryKeys.BALANCE_CALORIES],
    staleTime: QueryStaleTime.SHORT,
    queryFn: async () => {
      const user = guardGetUserFromLocalStorage();
      const response = await BalanceService.getCalorieDeviationApiV1BalanceCaloriesGet(user.id);

      return response.data;
    },
  });

  return {
    calorieDeviation: data as CalorieDeviationResponse | undefined,
    isLoading,
    isError,
    error,
    refetch,
  };
};
